(() => {
  const initialized = new WeakSet();

  function initialize(section) {
    if (!(section instanceof HTMLElement) || initialized.has(section)) return;
    const content = section.querySelector('#collection-description-content');
    const toggle = section.querySelector('#collection-description-toggle');
    const toggleText = toggle?.querySelector('.toggle-text');
    if (!content || !toggle || !toggleText) return;

    initialized.add(section);
    if (content.scrollHeight <= 200) {
      toggle.hidden = true;
      return;
    }

    content.classList.add('collapsed');
    toggle.addEventListener('click', () => {
      const expanded = content.classList.toggle('expanded');
      content.classList.toggle('collapsed', !expanded);
      toggleText.textContent = expanded ? 'Ver menos' : 'Ver mais';
    });
  }

  function scan(root = document) {
    if (root instanceof HTMLElement && root.matches('.collection-description')) initialize(root);
    root.querySelectorAll?.('.collection-description').forEach(initialize);
  }

  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
